import React, { useEffect, useState } from "react";
import InnerBannerBreadcrumb from "../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../hooks/useLanguageTranslation";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { resetSearch, setSearchInputValue } from "../redux/slice/sliceHome";
import { useGetSearchAPIQuery } from "../redux/services/apiHome";
import Loader from "../components/Loader";
import PaginationNew from "../components/Pagination/PaginationNew";
import useSeo from "../hooks/useSeo";
import searchCategories from "./SearchCategories.json";

const SearchPage = () => {
  const dispatch = useDispatch();
  const url = process.env.REACT_APP_IMAGE_URL;
  const { getText } = useLanguageTranslation();
  const { searchInputValue } = useSelector((state) => state.homeSlice);
  const [currentPage, setCurrentPage] = useState(0);
  const [text, setText] = useState(searchInputValue);
  const [category, setCategory] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [queryParams, setQueryParams] = useState({
    category: "",
    fromDate: "",
    toDate: "",
  });

  const [hasSearched, setHasSearched] = useState(false);
  const [searchError, setSearchError] = useState("");

  const {
    data: searchData = {},
    isLoading: searchIsLoading,
    isFetching: searchIsFetching,
  } = useGetSearchAPIQuery(
    {
      query: searchInputValue,
      page: currentPage,
      category: queryParams.category,
      fromDate: queryParams.fromDate,
      toDate: queryParams.toDate,
    },
    {
      skip: !searchInputValue,
    },
  );

  useEffect(() => {
    if (searchData?.pager?.total_pages) {
      setTotalPages(searchData.pager.total_pages - 1);
    } else {
      setTotalPages(0);
    }
  }, [searchData]);

  const { pathname } = useLocation();
  useSeo({ pathname });

  const handleSubmit = (e) => {
    e.preventDefault();
    setQueryParams({
      category,
      fromDate,
      toDate,
    });
    setHasSearched(true);

    if (!text.trim()) {
      setSearchError(
        getText("Please enter a search term", "कृपया खोज शब्द दर्ज करें"),
      );
      return;
    }

    setSearchError("");
    dispatch(setSearchInputValue(text));
  };

  const highlightText = (text, keyword) => {
    if (!keyword) return text;
    const regex = new RegExp(`(${keyword})`, "gi");
    return text.replace(regex, `<span className="highlight">$1</span>`);
  };

  if (searchIsLoading || searchIsFetching) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="/images/inner_aboutbann.jpg"
        title={getText("Search Results", "सर्च परिणाम")}
        titleLink={`/search`}
        levelTwo={false}
        levelThree={false}
        isActive={getText("Search Results", "सर्च परिणाम")}
      />
      <div className={`inner-container`}>
        <div className="container">
          <div className="director-section">
            <div className="container">
              {/* <Formik initialValues={initialValues} onSubmit={handleSubmit}>
                {({ values, handleChange, handleSubmit, resetForm }) => ( */}
              <form onSubmit={handleSubmit}>
                {/* <label htmlFor="search">Enter your keywords</label> */}
                <div className="search-page2">
                  <div className="container">
                    <div className="row">
                      <div className="col-12 col-sm-6 col-md-3 col-lg-3">
                        <label htmlFor="search">
                          {getText("Search", "खोज")}
                        </label>
                        <input
                          placeholder={getText("Search", "खोज")}
                          className="input-search"
                          name="search"
                          id="search"
                          type="text"
                          onChange={(e) => {
                            setText(e.target.value);
                            setSearchError("");
                          }}
                          value={text}
                          aria-invalid={!!searchError}
                          aria-describedby="search-error"
                        />
                        {searchError && (
                          <div
                            id="search-error"
                            role="alert"
                            className="error-message"
                          >
                            {searchError}
                          </div>
                        )}
                      </div>
                      <div className="col-12 col-sm-6 col-md-3 col-lg-3">
                        <label htmlFor="category">Category</label>
                        <select
                          name="category"
                          id="category"
                          className="input-select"
                          onChange={(e) => {
                            setCategory(e.target.value);
                          }}
                          value={category}
                          placeholder="category"
                        >
                          <option hidden>Select</option>
                          {searchCategories.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-12 col-sm-6 col-md-3 col-lg-3">
                        <label htmlFor="fromDate">From Date</label>
                        <input
                          className="form-control"
                          type="date"
                          name="fromDate"
                          onChange={(e) => setFromDate(e.target.value)}
                          value={fromDate}
                          required={toDate !== ""}

                          // value={queryParams.fromDate}
                        />
                      </div>
                      <div className="col-12 col-sm-6 col-md-3 col-lg-3">
                        <label htmlFor="toDate">To Date</label>
                        <input
                          className="form-control"
                          type="date"
                          name="toDate"
                          onChange={(e) => setToDate(e.target.value)}
                          value={toDate}
                          required={fromDate !== ""}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-sm-6 col-md-4 col-lg-4">
                        <button className="quick-btn" type="submit">
                          Search
                        </button>
                        <button
                          className="quick-btn"
                          type="button"
                          onClick={() => {
                            // Reset form values and state
                            dispatch(resetSearch());
                            setCategory("");
                            setFromDate("");
                            setToDate("");
                            setTotalPages(0);
                            setText("");
                            setHasSearched(false); // Reset the search flag
                            setQueryParams({
                              category: "",
                              fromDate: "",
                              toDate: "",
                            }); // Reset query params
                          }}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              {/* )}
              </Formik> */}

              <ul className="search-sec">
                {!searchInputValue && !hasSearched ? (
                  <li>
                    {getText(
                      "Please enter a keyword for search",
                      "कृपया खोज के लिए एक कीवर्ड दर्ज करें",
                    )}
                  </li>
                ) : searchData?.results?.length > 0 ? (
                  <>
                    <div
                      className="search-results-count"
                      // aria-label={`${searchData.results.length}{" "}
                      // ${getText("Records found", "रिकॉर्ड मिले")}`}
                      style={{ color: "green", marginBottom: "1rem" }}
                      role="alert"
                    >
                      {/* {searchData.results.length} */}
                      {searchData.pager.total_items}
                      {getText("Records found", "रिकॉर्ड मिले")}
                    </div>
                    {searchData.results.map((item, index) => (
                      // <li key={index}>
                      //   <Link to={item.url}>
                      //     <div className="search-title4">
                      //       <h2
                      //         dangerouslySetInnerHTML={{
                      //           __html: highlightText(
                      //             item.title,
                      //             searchInputValue
                      //           ),
                      //         }}
                      //       />
                      //     </div>
                      //   </Link>
                      //   <p
                      //     dangerouslySetInnerHTML={{
                      //       __html: highlightText(
                      //         item.description,
                      //         searchInputValue
                      //       ),
                      //     }}
                      //   />
                      // </li>
                      <li key={index}>
                        <Link
                          to={item.url}
                          className={
                            item.url.startsWith(url) ? "unclickable" : ""
                          }
                          onClick={(e) =>
                            item.url.startsWith(url) && e.preventDefault()
                          }
                          title={
                            item.url.startsWith(url)
                              ? "Data not available"
                              : undefined
                          }
                        >
                          <div className="search-title4">
                            <h2
                              dangerouslySetInnerHTML={{
                                __html: highlightText(
                                  item.title,
                                  searchInputValue,
                                ),
                              }}
                            />
                          </div>
                        </Link>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: highlightText(
                              item.description,
                              searchInputValue,
                            ),
                          }}
                        />
                      </li>
                    ))}
                  </>
                ) : hasSearched ? (
                  <>
                    <div
                      id="search-error"
                      role="alert"
                      className="error-message"
                    >
                      {getText(
                        "No matching records found",
                        "कोई मिलान रिकॉर्ड नहीं मिला",
                      )}
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </ul>
              {searchData?.results?.length > 0 && (
                <PaginationNew
                  setCurrentPage={setCurrentPage}
                  currentPage={currentPage}
                  totalPages={totalPages}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchPage;
